import { CallbackSetEvent } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/Qubit'

export const qubitTracking = (
  sku: string,
  eventType: CallbackSetEvent,
  callbackData: string | undefined,
  callbackURL: string | undefined,
  logger,
) => {
  if (!callbackData || !callbackURL) {
    return
  }

  const timestamp = Date.now()
  const qubitCallbackURL = callbackURL
    .replace('{callbackData}', `${callbackData}`)
    .replace('{timestamp}', `${timestamp}`)
    .replace('{sku}', `${sku}`)
    .replace('{eventType}', `${eventType.toLowerCase()}`)

  fetch(qubitCallbackURL, {
    method: 'GET',
    keepalive: true,
  })
    .then(() => {
      return
    })
    .catch((error) => {
      logger.warn(
        `Failed to send Qubit callback request with error: ${error.message}`,
      )
    })
}
